<template>
    <li class="listitem listitem-inverted">
        <cart-base>
            <template slot-scope="{ discounts, items, price }">
                <div class="card">
                    <div class="card-header">
                        <h3 class="uppercase">
                            {{ __('Kosár tartalma') }}
                        </h3>
                    </div>

                    <portal-target
                        v-if="portalAvailable"
                        name="checkout-cart-before"
                    />

                    <div
                        v-if="!items.length"
                        class="card-body"
                    >
                        {{ __('Kosarad jelenleg üres!') }}
                    </div>
                    <div
                        v-if="items.length"
                        class="card-body"
                    >
                        <div>

                            <table>
                                <thead>
                                <tr>
                                    <th>{{ __('Termék neve') }}</th>
                                    <th>{{ __('Ár') }}</th>
                                    <th>{{ __('Kedvezményes ár') }}</th>
                                    <th class="text-center">{{ __('Darab') }}</th>
                                    <th>{{ __('Összesen') }}</th>
                                    <th>
                                        <a href="#" @click="destroyCart" title="Összes termék törlése"
                                           style="position: relative; top: 2px;">
                                            <svg class="icon" aria-label="Összes termék törlése">
                                                <use xmlns:xlink="http://www.w3.org/1999/xlink"
                                                     xlink:href="#icon-close"></use>
                                            </svg>
                                        </a>
                                    </th>
                                </tr>
                                </thead>
                                <tbody>

                                <cart-item
                                    v-for="item in items"
                                    :key="item.id.identifier"
                                    :item="item"
                                />


                                </tbody>
                                <tfoot>
                                <tr class="mobile-flex">
                                    <th colspan="3" class="mobile-flex-1">{{ __('Kosárban összesen') }}:</th>
                                    <td><span class="cart-qty">{{ totalItemQuantity }}</span> {{ __('Darab') }}</td>
                                    <td>
                                        <div class="cc-sum-val cart_sum">
                                            {{ formatNegativePrice(price.gross) | currency(currencyFormat(items[0].currency)) }}
                                        </div>
                                    </td>
                                    <td></td>
                                </tr>

                                <tr v-if="shippingCost && shippingCost >= 0"
                                    class="cart-transport-cost mobile-flex">
                                    <th colspan="3" class="label mobile-flex-1">{{ __('Szállítási költség') }}:</th>
                                    <td><span class="price"></span></td>
                                    <td>
                                        <div class="cc-sum-val cart_sum">
                                            {{ shippingCost | currency(currencyFormat(items[0].currency)) }}
                                        </div>
                                    </td>
                                    <td></td>
                                </tr>

                                <tr class="cart-total mobile-flex" id="cart-total-cost-rows">
                                    <th colspan="4" class="mobile-flex-1">{{ __('Összesen') }}:</th>
                                    <td>
                                        <span class="total_price">
                                            {{ formatNegativePrice(parseFloat(price.gross) + parseFloat(shippingCost)) | currency(currencyFormat(items[0].currency)) }}
                                        </span>
                                    </td>
                                    <td></td>
                                </tr>
                                </tfoot>
                            </table>

                            <div
                                v-if="discounts.length"
                                class="cart-discounts"
                            >
                                <p class="card-subtitle">
                                    {{ __('Kedvezmények') }}
                                </p>
                                <component
                                    :is="discount.type"
                                    v-for="(discount, key) in discounts"
                                    :key="key"
                                    :discount="discount"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="grid grid-rows-2">
                    <div>
                        <FreeShippingFinderWidget
                            class="float-left"
                            :cart-empty="items.length === 0"
                        ></FreeShippingFinderWidget>
                    </div>
                    <div><coupon-redeem-form  class="float-left"></coupon-redeem-form></div>
                    </div>

                    <portal-target
                        v-if="portalAvailable"
                        name="checkout-cart-after"
                    />

                    <div>
                        <CartRelatedProduct />
                    </div>
                </div>
            </template>
        </cart-base>
    </li>
</template>

<script>
import {mapState} from 'vuex'
import {sumBy} from 'lodash'
import currencyFormatter from '../../mixins/currencyFormatter';
import FreeShippingFinderWidget from '../FreeShippingFinderWidget';
import CartRelatedProduct from './CartRelatedProduct';

export default {
    components: {
        FreeShippingFinderWidget,
        CartRelatedProduct
    },
    mixins: [currencyFormatter],

    data() {
        return {
            shippingMode: null,
            shippingCost: 0
        }
    },

    computed: {
        ...mapState('cart', [
            'items',
            'price'
        ]),

        totalItemQuantity() {
            return sumBy(this.items, 'quantity')
        },

        totalItemPrice() {
            return sumBy(this.items, (item) => parseFloat(item.price.gross) * item.quantity)
        },

        totalItemOriginalPrice() {
            return sumBy(this.items, (item) => parseFloat(item.originalPrice) * item.quantity)
        },

        portalAvailable() {
            return 'PortalTarget' in this.$options.components
        }
    },

    watch: {
        price() {
            this.updateShippingCost()
        }
    },

    mounted() {
        this.loadShippingMode()
        this.$bus.$on('free-shipping-amount-left', this.updateShippingCost)
    },

    methods: {
        async updateShippingCost() {
            try {
                const response = await axios.get('/api/shipping-cost')

                this.shippingCost = response.data

            } catch (exception) {
                this.shippingCost =  0
            }
        },

        async loadShippingMode() {
            try {
                const response = await axios.get('/api/min-value-shipping-discounts')

                this.shippingMode = response.data
            } catch (exception) {
                console.error('Could not load the free shipping state.')
            }
        },

        async destroyCart()
        {
            try {
                this.$loading.show()
                await axios.delete('/api/carts')

                window.location.reload();

            } catch (exception) {
                this.$loading.hide()
                console.error('Destroy Cart.')
            }
        }
    }

}
</script>
